"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.IKycDocuments = void 0;
// should we use split these classes to separate files?
class IModel {
}
class IEntityBase extends IModel {
}
class ICard extends IEntityBase {
}
class IKycDocuments {
}
exports.IKycDocuments = IKycDocuments;
class IUsers {
}
class IWallets {
}
class IClients {
}
class ICards {
}
class ICardRegistrations {
}
class IPayIns {
}
class IRefunds {
}
class ITransfers {
}
class IPayOuts {
}
class IEvents {
}
class IUBODeclarations {
}
class IReports {
}
//# sourceMappingURL=MangopayModels.js.map